import { Exclude, Type } from 'class-transformer';
import {
  IsBoolean,
  IsDate,
  IsDefined,
  IsInt,
  IsOptional,
  IsString,
  Length,
} from 'class-validator';

export class NpsSurveyCreateDto {
  @Exclude()
  id?: number;

  @IsDefined()
  @IsInt()
  @Type(() => Number)
  pieMerchantGroupId: number;

  @IsDefined()
  @IsString()
  @Length(1, 45)
  name: string;

  @IsDefined()
  @IsString()
  @Length(1, 255)
  description: string;

  @IsOptional()
  @IsDate()
  @Type(() => Date)
  startDate: Date;

  @IsOptional()
  @IsDate()
  @Type(() => Date)
  endDate: Date;

  @IsOptional()
  @IsBoolean()
  isActive: boolean;

  @Exclude()
  isOnline?: boolean;

  @IsOptional()
  @IsBoolean()
  isPublished: boolean;

  @Exclude()
  createdDate?: Date;

  @Exclude()
  modifiedDate?: Date;
}
